import { BASE_URL } from 'Config';

const BASE_API = 'api/v1';

type Request = {
  url?: string;
  method?: string;
  headers?: { [key: string]: string };
  body?: { [key: string]: string } | string;
  queryParams?: { [key: string]: string };
};

export const fetchManager =
  (baseAPI = BASE_API) =>
  async ({ url, method, queryParams, body }: Request): Promise<unknown> => {
    let urlFormatted = url;
    const requestOptions: RequestInit = {
      method,
      headers: { 'Content-Type': 'application/json' },
    };
    if (body) {
      requestOptions.body = JSON.stringify(body);
    }
    if (queryParams) {
      const query = Object.entries(queryParams)
        .map(kv => kv.map(encodeURIComponent).join('='))
        .join('&');
      urlFormatted += `?${query}`;
    }
    const response = await fetch(`${BASE_URL}/${baseAPI}/${urlFormatted}`, requestOptions);
    if (!response.ok) {
      return Promise.reject(response);
    }
    return response.json();
  };
